import { CacheStrategy } from '@rammetec/data-access';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { WORK_SHIFT } from '../types/work-shift.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for WorkShift (turno of a WorkCalendar).
 * Subcollection: org/{orgId}/work-calendar/{workCalendarId}/shift
 *
 * Resolve repository with context: { orgId, workCalendarId }.
 * No lifecycle / audit — same discipline as SizeOccurrence.
 */
export const workShiftDescriptor = {
    name: WORK_SHIFT,
    label: 'Turno',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/work-calendar/{workCalendarId}/shift',
    pathPatternKeys: {
        orgId: 'string',
        workCalendarId: 'string',
    },
    version: 1,
    description: 'Shift line of a WorkCalendar (start + duration, optional meal break, vigência)',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique shift identifier',
        },
        {
            name: 'name',
            label: 'Nome',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.NAME,
            description: 'Display label (e.g. Turno 1). Not a key — two rows may share a name.',
        },
        {
            name: 'order',
            label: 'Ordem',
            type: 'number',
            required: true,
            description: 'Display order within the calendar',
        },
        {
            name: 'weekdays',
            label: 'Dias da semana',
            type: 'array',
            required: true,
            description: 'Operational weekdays: 0=Sun .. 6=Sat. Non-empty, unique.',
        },
        {
            name: 'startMinuteOfDay',
            label: 'Início',
            type: 'number',
            required: true,
            description: 'Wall-clock minute of day (0..1439) when the shift starts',
        },
        {
            name: 'durationMs',
            label: 'Duração',
            type: 'number',
            required: true,
            description: 'Duration in milliseconds (ADR 0001). 1..86_400_000 (≤ 24h)',
        },
        {
            name: 'breakStartMinuteOfDay',
            label: 'Início do intervalo',
            type: 'number',
            required: false,
            description: 'Meal/break wall-clock minute. Pair with breakDurationMs — both or neither.',
        },
        {
            name: 'breakDurationMs',
            label: 'Duração do intervalo',
            type: 'number',
            required: false,
            description: 'Meal/break duration in milliseconds. Pair with breakStartMinuteOfDay.',
        },
        {
            name: 'effectiveFrom',
            label: 'Vigência de',
            type: 'date',
            required: false,
            description: 'Inclusive operational-day vigência start (UTC-midnight business date)',
        },
        {
            name: 'effectiveTo',
            label: 'Vigência até',
            type: 'date',
            required: false,
            description: 'Inclusive operational-day vigência end (UTC-midnight business date)',
        },
    ],
};
//# sourceMappingURL=work-shift.descriptor.js.map